import '@/core/setup/env';

import Vue from 'vue';
import router from '@/core/routes';
import store from '@/core/store';

import '@/core/setup/api';
import '@/core/shared/setup/launchDarkly';
import '@/core/shared/setup/permissions';

import initSentry from '@/core/setup/sentry';
import localize from '@/core/shared/localization';
import registerServiceWorker from '@/core/shared/setup/registerServiceWorker';
import '@/core/setup/composition-api';

import App from '@/App';

initSentry();

const i18n = localize(window.sbvrenv.BROWSER_LOCALE, 'monitor');

Vue.config.productionTip = false;

registerServiceWorker({
  store,
  i18n,
  projectName: 'Monitor Station',
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render (h) {
    return h(App);
  },
  components: { App },
});
